import { createFileRoute } from "@tanstack/react-router";
import MentalHealthEducation from "@/pages/MentalHealthEducation";
export const Route = createFileRoute("/mental-health-resources")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Mental Health Resources | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Mental health resources and crisis support from Neuro Wellness TMS in Coral Springs, FL. Helplines, guides, and treatment options for depression and anxiety.",
        },
        {
          property: "og:title",
          content: "Mental Health Resources | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Mental health resources and crisis support from Neuro Wellness TMS in Coral Springs, FL. Helplines, guides, and treatment options for depression and anxiety.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/mental-health-resources",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/mental-health-resources",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <MentalHealthEducation />;
}
